import $ from "jquery";

// $('.gfield input[type="checkbox"]').after('<span class="checkmark"></span>');

$("#select-membership").change(function() {
  $("#associate-membership-application").removeClass("active");
  $("#active-grower-membership-application").removeClass("active");
  $("#school-membership-application").removeClass("active");
  $("#student-membership-application").removeClass("active");

  if ($(this).val() == "active-grower-membership-application") {
    $("#active-grower-membership-application").addClass("active");
  }
  if ($(this).val() == "associate-membership-application") {
    $("#associate-membership-application").addClass("active");
  }
  if ($(this).val() == "school-membership-application") {
    $("#school-membership-application").addClass("active");
  }
  if ($(this).val() == "student-membership-application") {
    $("#student-membership-application").addClass("active");
  }
  // alert( "Handler for .change() called." );
});
